export interface XeroProductSalesDetails {
  accountCode?:string,
  taxType?:string,
  unitPrice?:number
}

export interface XeroProductPurchasDetails {
  cOGSAccountCode?:string,
  taxType?:string,
  unitPrice?:number
}

export interface XeroProduct {
  code:string,
  description:string,
  inventoryAssetAccountCode?:string
  isPurchased:boolean,
  isSold:boolean,
  isTrackedAsInventory:boolean
  itemID:string,
  name:string,
  purchaseDescription:string  
  purchaseDetails:XeroProductPurchasDetails,
  quantityOnHand?:string
  salesDetails:XeroProductSalesDetails
  totalCostPool:number
  updatedDateUTC:string
}